import { PensionScheme, PaginationMeta, ClientFilter } from '../types';

export interface IPensionSchemeState {
  pensionSchemes: PensionScheme[];
  pensionSchemePaginationMeta: PaginationMeta;
  filterPensionSchemes: PensionScheme[];
  appliedFilters: ClientFilter;
}

export const PensionSchemeState: IPensionSchemeState = {
  pensionSchemes: [],
  pensionSchemePaginationMeta: {} as PaginationMeta,
  filterPensionSchemes: [],
  appliedFilters: {
    selectedClientEntities: [],
    selectedClientIds: [],
    selectedReportingPeriod: [],
    searchKeyword: ''
  }
};
